<div class="container">
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h1 class="h1">Wichtige Teilnahmebedingungen für den Ferienpass </h1>
        <p>
            Damit der Ferienpass reibungslos und sicher für alle ablaufen kann, bitten wir Sie, folgende Punkte
            aufmerksam zu lesen und bei der Anmeldung zu bestätigen:
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Gesundheit & Betreuung</h3>
        <p>
            Bitte informieren Sie die Betreuer*innen vor Ort unbedingt über Allergien und regelmäßig einzunehmende
            Medikamente Ihres Kindes. Diese Informationen sind entscheidend, um im Notfall schnell und richtig
            reagieren zu können.
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Unterwegs in der Kleingruppe</h3>
        <p>
            Ich bin damit einverstanden, dass mein Kind bei bestimmten Aktionen in einer Kleingruppe von mindestens
            drei Kindern ohne direkte Begleitung durch eine Aufsichtsperson unterwegs ist. Die Gruppen bewegen sich
            nur in abgesprochenen und sicheren Bereichen.
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Datenschutz</h3>
        <p>
            Ich erkläre mich damit einverstanden, dass die persönlichen Daten meines Kindes ausschließlich zur
            Durchführung der Aktionen an die beteiligten Organisationen weitergegeben werden. Eine Weitergabe
            darüber hinaus erfolgt nicht.
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Abmeldung & Rückerstattung</h3>
        <ul>
            <li>
                Sollte mein Kind an einer gebuchten Aktion nicht teilnehmen können, verpflichte ich mich, es rechtzeitig
                vorab per WhatsApp unter 04608 – 972 09 60 abzumelden.
            </li>
            <li>Eine Rückerstattung der Teilnahmegebühr erfolgt nur, wenn der Platz neu vergeben werden kann.</li>
            <li>Aus versicherungstechnischen Gründen ist es nicht erlaubt, Ersatzkinder zu schicken.</li>
            <li>Bitte haben Sie Verständnis, dass während der Ferien keine Anfragen per Telefon oder E-Mail beantwortet
                werden können.
            </li>
        </ul>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Regelverstöße</h3>
        <ul>
            <li>Ich bin mir bewusst, dass bei schweren oder wiederholten Regelverstößen während einer Aktion mein Kind
                von der weiteren Teilnahme ausgeschlossen werden kann
            </li>
            <li>In diesem Fall erkläre ich mich bereit, es nach vorheriger Rücksprache selbst abzuholen oder die Kosten
                für den Rücktransport zu übernehmen.
            </li>
        </ul>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Transport durch Veranstalter</h3>
        <p>
            Ich bin damit einverstanden, dass mein Kind bei Bedarf mit Fahrzeugen des Veranstalters oder der
            beteiligten Organisationen transportiert wird.
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Fotos & Öffentlichkeitsarbeit</h3>
        <ul>
            <li>Ich erkläre mich damit einverstanden, dass im Rahmen der Ferienpass-Aktionen Fotos und Videos meines
                Kindes gemacht und für die Öffentlichkeitsarbeit der beteiligten Organisationen verwendet werden dürfen
                (z. B. Website, Presseberichte, Social Media).
            </li>
            <li>Wenn Sie nicht möchten, dass Ihr Kind fotografiert oder gefilmt wird, senden Sie bitte eine E-Mail an:
                <a href="mailto:ferienpass@toj-online.de">ferienpass@toj-online.de</a></li>
        </ul>
    </div>

    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Kleidung & Verpflegung</h3>
        <ul>
            <li> Ich achte darauf, dass mein Kind bei den Aktionen angemessen gekleidet erscheint (z. B. lange Hose und
                Kopfbedeckung bei Aktionen im Wald).
            </li>
            <li>Außerdem sorge ich dafür, dass es ausreichend Verpflegung dabei hat.</li>
        </ul>

    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Ehrliche Angaben</h3>
        <ul>
            <li>Ich bestätige, dass alle Angaben zu meinem Kind korrekt und vollständig gemacht werden.</li>
            <li>Mir ist bewusst, dass falsche oder unvollständige Angaben zum Ausschluss von allen Ferienpass-Aktionen
                führen können.
            </li>
        </ul>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h3>Teilnahmegebühren</h3>
        <p>
            Ich verpflichte mich, die Teilnahmegebühren innerhalb von 3 Werktagen nach Erhalt der
            Buchungsbestätigung per E-Mail zu überweisen.
        </p>
    </div>

</div>
